import ActionType from './ActionType';
import { IUser } from '../Models/User';
import { AppConfig } from '../Models/AppConfig';
import ITenant from '../Models/Tenant';

export interface IAuthState {
  tenants: ITenant[];
  user: IUser | null;
  appConfig: AppConfig | null;
  authError: string | string[];
  isUserRootContributor: boolean;
}

export const initialAuthState: IAuthState =  { tenants: [], user: null, appConfig: null, authError: Array<string>(), isUserRootContributor: false } as IAuthState

export type authAction =
  | { type: ActionType.SET_TEANANTS; data: ITenant[] }
  | { type: ActionType.SET_CONFIG; data: AppConfig }
  | { type: ActionType.SET_USER; data: IUser | null }
  | { type: ActionType.SET_IS_USER_ROOT_CONTRIBUTER; data: boolean }
  | { type: ActionType.SET_AUTH_ERROR; data: string | string[] };

export const authReducer = (
  state: IAuthState = initialAuthState,
  action: authAction
) => {
  switch (action.type) {
    case ActionType.SET_TEANANTS:
      return { ...state, tenants: action.data };
    case ActionType.SET_IS_USER_ROOT_CONTRIBUTER: 
    return { ...state, isUserRootContributor: action.data };
    case ActionType.SET_CONFIG:
      return { ...state, appConfig: action.data };
    case ActionType.SET_USER:
      return { ...state, user: action.data };
    case ActionType.SET_AUTH_ERROR: {
      return { ...state, authError: action.data };
    }

    default:
      return state;
  }
};
